import React from "react";
import { ensure, depascalize, Text } from "sprint-common-web";

import { getStatusName } from "../../../../orders/common/utils/getStatusName";
import { OnPremOrderStatus } from "../../../types/OnPremOrderStatus";
import { OrderStatus } from "../../../types/OrderStatus";
import { OrderAuditItem } from "../AuditItem";
import { OrderAuditType } from "../AuditListAside";

type Props = {
    item: OrderAuditItem;
    type: OrderAuditType;
};

export const StatusChangeInfo: React.FunctionComponent<Props> = ({ item, type }: Props) => {
    ensure(item.statusFrom);
    ensure(item.statusTo);

    const renderStatus = (status: OrderStatus | OnPremOrderStatus) => {
        if (type === OrderAuditType.Cloud) {
            return getStatusName(status as OrderStatus);
        }
        return depascalize(OnPremOrderStatus[status as OnPremOrderStatus]);
    };

    return (
        <div style={{ display: "flex", justifyContent: "left", gap: 4 }}>
            <Text value="Status change: " variant="smallPlus" />
            <Text
                variant="smallPlus"
                styles={{ root: { fontWeight: 600 } }}
                value={` ${renderStatus(item.statusFrom)} → ${renderStatus(item.statusTo)}`}
            />
        </div>
    );
};
